import { useState, useEffect } from 'react';

/**
 * Custom Hook zum Speichern von Eingabewerten im localStorage
 * @param {string} key - Eindeutiger Schlüssel für localStorage
 * @param {string} initialValue - Initialer Wert, falls nichts gespeichert ist
 * @returns {Array} [value, setValue, clearValue] - Wert, Setter-Funktion, Clear-Funktion
 */
export function usePersistentInput(key, initialValue = '') {
  // Initialen Wert aus localStorage laden oder initialValue verwenden
  const [value, setValue] = useState(() => {
    try {
      const item = localStorage.getItem(key);
      return item !== null ? item : initialValue;
    } catch (error) {
      console.warn(`Fehler beim Laden von localStorage key "${key}":`, error);
      return initialValue;
    }
  });

  // Wert in localStorage speichern, wenn er sich ändert
  useEffect(() => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.warn(`Fehler beim Speichern in localStorage key "${key}":`, error);
    }
  }, [key, value]);

  // Funktion zum Löschen des gespeicherten Werts
  const clearValue = () => {
    try {
      localStorage.removeItem(key);
      setValue(initialValue);
    } catch (error) {
      console.warn(`Fehler beim Löschen von localStorage key "${key}":`, error);
    }
  };

  return [value, setValue, clearValue];
}
